import * as actionTypes from "../Actions/action-types";
const initialState = {
  statusOrec: false,
  orderCurrent: [],
  orderPast: [],
  isLoadingOrec: true,
  errorOrec: false
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_RECORDS:
      return {
        ...state,
        orderCurrent: action.orderCurrent,
        orderPast: action.orderPast,
        isLoadingOrec: false,
        errorOrec: false, //Orec--->OrderRecor
        statusOrec: true
      };
    case actionTypes.FETCHED_RECORDS_FAILS:
      return {
        ...state,
        errorOrec: true,
        isLoadingOrec: false,
        statusOrec: false
      };

    case actionTypes.IS_LOADING_RECORDS:
      return {
        ...state,
        isLoadingOrec: true,
        errorOrec: false,
        statusOrec: false
      };
      case actionTypes.RESET_RECORDS:
        return {
          statusOrec: false,
          orderCurrent: [],
          orderPast: [],
          isLoadingOrec: true,
          errorOrec: false
        }


    default:
      return state;
  }
};
export default reducer;
